module.exports = __webpack_public_path__ + "static/img/solutionText2.1d945e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText2.png
// module id = LZ5K
// module chunks = 1